<!-- 由 woniu6162 创建于 2019-08-23 星期五 -->
<template>
  <div class="food-search">
    <AppBar title="食物档案" :placeholder="true" :zIndex="10"> </AppBar>
    <form @submit.prevent action="javascript:return true">
      <van-field
        type="search"
        ref="vanfield"
        v-model="foodname"
        placeholder="请输入食物名称"
        @keypress="searchFn"
      >
        <v-svg slot="left-icon" icon="iconsousuo1" />
        <div slot="button" class="search_btn" @click="searchFood">搜索</div>
      </van-field>
    </form>
    <div class="f_search_list">
      <scroll ref="scroll" :data="foodList" :pullup="true" @pullup="pullup">
        <template v-for="(item, index) in this.foodList">
          <div :key="index" class="food_wrap" @click="toDetails(item)">
            <div class="image">
              <img class="icon" :src="item.thumb_image_url" />
              <img
                class="flag"
                v-if="item.is_super"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
                alt=""
              />
            </div>
            <div class="f_w_info">
              <div class="w_i_wrap">
                <div class="i_w_name">{{ item.name }}</div>
                <div class="i_w_calory">{{ `${item.calory}kcal/100g` }}</div>
              </div>
              <!-- <template v-if="item.health_light==1">
                <div
                  class="w_i_light"
                  style="color:#dc0050;"
                >推荐</div>
              </template>
              <template v-if="item.health_light==2">
                <div
                  class="w_i_light"
                  style="color:#f9a600;"
                >适量</div>
              </template>
              <template v-if="item.health_light==3">
                <div
                  class="w_i_light"
                  style="color:#bbb;"
                >不推荐</div>
                </template> -->
            </div>
          </div>
        </template>
        <div v-if="!nextPage" class="no_more">没有更多了~</div>
      </scroll>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import AppBar from '@/components/app/nav-bar/index.vue'
import scroll from '@/components/scroll'
export default {
  name: 'calorie-query-search',

  mixins: [],

  components: { scroll, AppBar },

  props: {},

  data() {
    return {
      loaded: true,
      foodname: '',
      page: 1,
      pagesize: 100,
      nextPage: 1,
      foodList: []
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  activated() {
    if (this.$refs.scroll) {
      this.$refs.scroll.refresh()
      this.$refs.scroll.scrollTo(0, this.top, 0)
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let routeName = ['calorie-query-index', 'wegymer-dietician']
      if (routeName.includes(from.name)) {
        vm.$nextTick(() => {
          vm.$refs.vanfield.focus()
        })
        vm.foodList = []
        vm.page = 1
        vm.top = 0
        vm.foodname = ''
        setTimeout(() => {
          vm.nextPage = 1
        }, 1000)
      }
      if (to.name == 'calorie-query-index') {
        vm.nextPage = 0
        vm.foodList = []
      }
    })
  },

  destroyed() {},

  methods: {
    // 搜寻食物:接口
    getFoodData() {
      this.loaded = false
      let params = {
        name: this.foodname,
        page: this.page,
        limit: this.pagesize
      }
      this.$http
        .getApp('member/Foods/foodsList', params)
        .then(
          (rs) => {
            if (rs.data.code === 200) {
              this.loaded = true
              let result = rs.data.data
              this.foodList = this.foodList.concat(result)
              if (!result || !result.length) {
                this.nextPage = 0
              }
              this.page++
            } else {
              this.$dialog.alert({
                title: '提示',
                message: res.data.msg
              })
            }
          },
          (err) => {}
        )
        .finally(() => {
          this.loaded = true
        })
    },
    // 搜寻食物:触发按钮
    searchFn(e) {
      var keycode = e.keyCode
      if (String(keycode) === '13') {
        this.searchFood()
      }
    },
    // 搜寻食物
    searchFood() {
      this.nextPage = 1
      this.page = 1
      this.foodList = []
      this.getFoodData()
    },
    // 跳转到食物详情页
    toDetails(val) {
      this.top = this.$refs['scroll'].scrollTop
      if (val.is_super) {
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: { id: val.id, name: val.name }
        })
      } else {
        this.$router.push({
          name: 'calorie-query-food-info',
          query: { foodid: val.id, name: val.name }
        })
      }
    },
    // 上拉加载
    pullup(val) {
      if (!this.nextPage) {
        return false
      }
      this.getFoodData()
    }
  }
}
</script>

<style lang="scss">
.food-search {
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  // input['search']样式
  input[type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
    position: relative;
    height: 4.5vw;
    width: 4.5vw;
    border-radius: 50%;
    background: #ebebeb
      url('https://cdnvue.gymcity.com.cn/uploads/6e82263ee6dbc1cfd43149f998400d3f.png')
      no-repeat center;
    background-size: 5vw 5vw;
  }

  .van-field {
    display: flex;
    align-items: center;
    position: relative;
    height: 14vw;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 200;

    svg {
      width: 4.3vw;
      height: 4.3vw;
      position: absolute;
      z-index: 200;
      left: 7vw;
      top: 4.8vw;
    }

    input {
      background: #f5f5f5;
      border-radius: 1.1vw;
      padding: 1.8vw 3.7vw 1.8vw 8.7vw;
    }
  }

  .search_btn {
    color: #333;
    border-radius: 2vw;
    font-size: 3.5vw;
    font-weight: bold;
  }

  .f_search_list {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    padding: 0.1vw 5.3vw;
    box-sizing: border-box;
    transform: translate3d(0, 0, 0);

    .food_wrap {
      display: flex;
      align-items: center;

      .image {
        position: relative;
        width: 16vw;
        height: 12vw;

        .icon {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .flag {
          width: 100%;
          position: absolute;
          left: 50%;
          bottom: 0%;
          transform: translate(-50%, 0%);
        }
      }

      .f_w_info {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 3vw 0 3vw 2.7vw;
        box-sizing: border-box;
        color: #3e4047;
        border-bottom: 0.2vw solid #f5f5f5;
        overflow: hidden;

        .w_i_wrap {
          widows: 100%;
          text-align: left;
          overflow: hidden;

          .i_w_name {
            font-size: 4.3vw;
            line-height: 5.9vw;
          }

          .i_w_calory {
            font-size: 3.2vw;
            line-height: 4.5vw;
          }
        }

        .w_i_light {
          font-size: 3.6vw;
          min-width: fit-content;
          margin-left: 4vw;
        }

        svg {
          min-width: 5.3vw;
          height: 5.1vw;
        }
      }
    }

    .no_more {
      text-align: center;
      margin: 4vw 0 0 0;
      color: #bbb;
      padding: 3.2vw 0;
      font-size: 2.93vw;
      // border-top: 0.13vw solid #bbb;
    }
  }
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
